function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Marker",
  x: 0,
  y: 0,
  width: 47,
  height: 57.649,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: -3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Marker-2",
  "data-name": "Marker",
  transform: "translate(-144.301 -2.001)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 144.3, 2)",
  filter: "url(#Marker)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Marker-3",
  "data-name": "Marker",
  d: "M140.053-500.942a17.847,17.847,0,0,0-9.886,4.343,17.871,17.871,0,0,0-5.638,10,20.377,20.377,0,0,0,.01,6.134,23.145,23.145,0,0,0,1.619,4.991c1.467,3.114,3.457,5.81,8.391,11.343a75.779,75.779,0,0,1,6.572,8.077c.6.885.733.914,1.181.21a77.882,77.882,0,0,1,6.829-8.429,82.513,82.513,0,0,0,5.781-6.962c3.3-4.61,4.8-9.505,4.3-14.067a17.521,17.521,0,0,0-14.458-15.458A21.8,21.8,0,0,0,140.053-500.942Z",
  transform: "translate(-118.3 510)",
  fill: "#fff"
})));

var SvgMarker = function SvgMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 57.649,
    viewBox: "0 0 47 57.649",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marker.ff762d09.svg";
export { ForwardRef as ReactComponent };